import gql from "graphql-tag";
let showQueryId;

export const GET_PINS = gql`
  {
    getVenues {
      data {
        _id
        lat
        long
        shows {
          data {
            name
            start_time
            end_time
          }
        }
      }
    }
  }
`;

export const GET_VENUES = gql`
  {
    getVenues {
      data {
        _id
        name
        address
        thumbnail
        lat
        long
      }
    }
  }
`;

export const CREATE_VENUE_MUTATION = gql`
  mutation createVenueMutation(
    $name: String!
    $address: String!
    $lat: Float!
    $long: Float!
  ) {
    createVenue(
      data: { name: $name, address: $address, lat: $lat, long: $long }
    ) {
      _id
      name
      address
      lat
      long
    }
  }
`;

export const GET_SHOWS = gql`
  {
    getShows {
      data {
        _id
        name
        start_time
        end_time
        thumbnail
        venue {
          name
        }
      }
    }
  }
`;

export const FIND_SHOW = gql`
  {
  findShowByID (id: ${showQueryId}) {
    _id
    name
    start_time
    end_time
    thumbnail
  }
}
`;

export const FIND_VENUE = gql`
  {
    findVenueByID(id: "310757662346182720") {
      _id
      name
      address
      thumbnail
      shows {
        data {
          name
          start_time
          end_time
          thumbnail
        }
      }
    }
  }
`;
